import { Controller } from '@hotwired/stimulus'

// Бургер-меню хаба: открывается по кнопке, закрывается кликом вне и по Escape.
export default class extends Controller {
  static targets = ['panel']

  connect() {
    this.closeOnOutside = (e) => { if (!this.element.contains(e.target)) this.close() }
    this.closeOnEscape = (e) => { if (e.key === 'Escape') this.close() }
    document.addEventListener('click', this.closeOnOutside)
    document.addEventListener('keydown', this.closeOnEscape)
  }

  disconnect() {
    document.removeEventListener('click', this.closeOnOutside)
    document.removeEventListener('keydown', this.closeOnEscape)
  }

  toggle(event) {
    event.stopPropagation()
    this.panelTarget.classList.toggle('hidden')
    this.panelTarget.classList.toggle('flex')
  }

  close() {
    this.panelTarget.classList.add('hidden')
    this.panelTarget.classList.remove('flex')
  }
}
